// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgTrophy = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2.2a.6.6 0 0 1 .6-.6h6.8a.6.6 0 0 1 .6.6v1.018a2.718 2.718 0 0 1 .611 5.253l-.806.293a.603.603 0 0 1-.136.032 4.005 4.005 0 0 1-3.069 2.36V13.2h2a.6.6 0 1 1 0 1.2H5.4a.6.6 0 1 1 0-1.2h2v-2.045a4.005 4.005 0 0 1-3.069-2.359.602.602 0 0 1-.136-.032l-.806-.293A2.717 2.717 0 0 1 4 3.218V2.2Zm0 2.233a1.518 1.518 0 0 0-.201 2.91l.207.075A4.058 4.058 0 0 1 4 7.2V4.433ZM12 7.2V4.433a1.518 1.518 0 0 1 .201 2.91l-.207.075c.004-.072.006-.145.006-.218ZM5.2 2.8v4.4a2.8 2.8 0 0 0 5.6 0V2.8H5.2Z"
    />
  </svg>
)

export default SvgTrophy
